export default __webpack_public_path__ + "static/media/logo.66b6ed5e.svg";